/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./pdf-viewer.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/router";
import * as i3 from "./pdf-viewer.component";
import * as i4 from "../../core/auth.service";
import * as i5 from "@ngx-translate/core";
var styles_PdfViewerComponent = [i0.styles];
var RenderType_PdfViewerComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PdfViewerComponent, data: {} });
export { RenderType_PdfViewerComponent as RenderType_PdfViewerComponent };
export function View_PdfViewerComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(1, 212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null), (_l()(), i1.ɵted(-1, null, ["\n\n"]))], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_PdfViewerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "pdf-viewer", [], null, null, null, View_PdfViewerComponent_0, RenderType_PdfViewerComponent)), i1.ɵdid(1, 114688, null, 0, i3.PdfViewerComponent, [i2.ActivatedRoute, i2.Router, i4.AuthService, i5.TranslateService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PdfViewerComponentNgFactory = i1.ɵccf("pdf-viewer", i3.PdfViewerComponent, View_PdfViewerComponent_Host_0, {}, {}, []);
export { PdfViewerComponentNgFactory as PdfViewerComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer.component.ngfactory.js.pre-build-optimizer.js